import React from 'react';
import { GithubIcon } from 'lucide-react';
import type { Project } from '../types/project';
import { StatusTag } from './StatusTag';
export function ProjectCard({
  project
}: {
  project: Project;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-hairline bg-panel p-7" data-id="element-190" data-mp="1nvze9dl86y02">
      <div className="flex items-start justify-between gap-4" data-id="element-191" data-mp="1sthpjamptpb8">
        <div data-id="element-192" data-mp="1sryafncspkb1">
          <h3 className="font-mono text-xl font-bold tracking-tight text-ink-hi" data-id="element-193" data-mp="2gk4z00ca4mzw">{project.name}</h3>
          <p className="mt-1.5 font-mono text-sm text-magenta" data-id="element-194" data-mp="2liokjzmynwrq">{project.tagline}</p>
        </div>
        <StatusTag status={project.status} data-id="element-195" data-mp="26lxu4fv9lve9" />
      </div>

      <p className="mt-5 text-[15px] leading-relaxed text-ink-mid" data-id="element-196" data-mp="26lfr90e3kixd">{project.summary}</p>

      <div className="mt-5 border-l-2 border-hairline pl-4" data-id="element-197" data-mp="2bj7gfmncxqxv">
        <p className="font-mono text-[11px] uppercase tracking-widest text-ink-mid" data-id="element-198" data-mp="v60thue2dn17">El concepto</p>
        <p className="mt-1.5 text-[15px] leading-relaxed text-ink-hi" data-id="element-199" data-mp="10651sx4tjbgc">{project.concept}</p>
      </div>

      <ul className="mt-6 space-y-2.5" data-id="element-200" data-mp="1g4ke6l0ffim">
        {project.points.map(point => <li key={point} className="flex gap-3 text-[14px] leading-relaxed text-ink-mid" data-id="element-201" data-mp="3sn7aeup43fr9">
            <span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-teal-dim" aria-hidden="true" data-id="element-202" data-mp="ahb22izeawdg" />
            {point}
          </li>)}
      </ul>

      {project.metrics ? <dl className="mt-6 grid grid-cols-3 gap-px overflow-hidden rounded-lg border border-hairline bg-hairline" data-id="element-203" data-mp="5kknk038o8u5">
          {project.metrics.map(m => <div key={m.label} className="bg-panelalt px-3 py-3" data-id="element-204" data-mp="ffmaqqdyf0u3">
              <dt className="font-mono text-[10px] uppercase tracking-wider text-ink-mid" data-id="element-205" data-mp="t8byaz94sdtb">
                {m.label}
              </dt>
              <dd className="mt-1 font-mono text-sm font-medium text-teal" data-id="element-206" data-mp="p7i982jycsyu">{m.value}</dd>
            </div>)}
        </dl> : null}

      <div className="mt-auto pt-7" data-id="element-207" data-mp="y6x0v5buv9kx">
        <ul className="flex flex-wrap gap-2" data-id="element-208" data-mp="y7ycbaws9y36">
          {project.stack.map(s => <li key={s} className="rounded-md border border-hairline bg-panelalt px-2.5 py-1 font-mono text-xs text-ink-mid" data-id="element-209" data-mp="3rzo8dvmg7pab">
              {s}
            </li>)}
        </ul>
        <div className="mt-5 flex items-center justify-between border-t border-hairline pt-4" data-id="element-210" data-mp="4tdt656va202">
          <span className="font-mono text-xs text-ink-mid" data-id="element-211" data-mp="9lnnryixfq8o">
            {project.languages.join(' · ')} — {project.license}
          </span>
          <a href={project.repo} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 font-mono text-xs text-ink-hi transition-colors duration-150 ease-out hover:text-teal focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-212" data-mp="embc2cfrtsz7">
            <GithubIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-213" data-mp="2pc9vmlk3avqr" />
            Ver repo
          </a>
        </div>
      </div>
    </article>;
}